import React from 'react';
import styled from 'styled-components';
import { Avatar } from '@routific/hive';

const StyledAvatar = styled(Avatar)`
  background-color: gray;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BlankAvatar: React.FC<{ size?: number | 'small' | 'large'; children?: React.ReactNode }> = ({ size, children }) => (
  <StyledAvatar
    size={size || 16}
  >
    {children}
  </StyledAvatar>
);

export default BlankAvatar;
